import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CustomerspagesService } from '../customerspages.service';
import { CommonModule } from '@angular/common';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';
import { DOCUMENT } from '@angular/common';
import { UrlParamsPipe } from 'src/app/shared/utilities/url-params.pipe';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-customer-rating-and-features',
  templateUrl: './customer-rating-and-features.component.html',
  styleUrls: ['./customer-rating-and-features.component.scss'],
  imports: [CommonModule, ToHtmlPipe, UrlParamsPipe],
})
export class CustomerRatingAndFeaturesComponent implements OnInit, OnDestroy {
  queryParams: any;
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private customersPagesService: CustomerspagesService,
    private route: ActivatedRoute
  ) {
    this.subscriptions = [];
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
    });
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  subscriptions: Subscription[];
  isPagination: boolean = true;
  ratingData: any;
  otherFeaturesData: any;

  ngOnInit(): void {

    this.customersPagesService.customersData$.subscribe(data => {
      if (data != null) {
        this.ratingData = {
          title: data.psCustomerRatingPanel?.[0]?.fields?.title,
          desc: data.psCustomerRatingPanel?.[0]?.fields?.textContent,
          rating: data.psCustomerRatingPanel?.[0]?.fields?.psMetric,
        };
        this.otherFeaturesData = {
          title: data?.psCustomerStoryOtherFeaturesPanel?.[0]?.fields?.title,
          desc: data?.psCustomerStoryOtherFeaturesPanel?.[0]?.fields?.content
            ?.content?.[0]?.content?.[0]?.value,
          cards:
            data?.psCustomerStoryOtherFeaturesPanel?.[0]?.fields?.components,
        };
      }
    });
  }

  setWidget() {}
}
